import { Action } from '../actions';
import { SearchSortOrder } from '../graphql/gen/types';
import { SearchState } from '../models/search';
import { ALL_DOCUMENT_TYPES } from '../views/logged_in/search/useSearch';

const DEFAULT_STATE: SearchState = { input: '', filters: ALL_DOCUMENT_TYPES, sortOrder: SearchSortOrder.Score };

export function searchReducer(state: SearchState = DEFAULT_STATE, action: Action): SearchState {
  switch (action.type) {
    case 'searchInputChanged': {
      return { ...state, input: action.payload.newInput };
    }
    case 'searchFilterChanged': {
      return { ...state, filters: action.payload.newFilters };
    }
    case 'searchSortOrderChanged': {
      return { ...state, sortOrder: action.payload.newSortOrder };
    }
  }
  return state;
}
